export default "<p>cfg-foxbit works!</p>\n";